/**
 * API配置模块
 */

// 基本API地址
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

// 请求超时时间（毫秒）
export const API_TIMEOUT = 30000;

// API版本
export const API_VERSION = "v1";
